
/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  FamilySitemapEntry,
  LocationSitemapEntry,
  TagSitemapEntry,
} from '../models';
import {
    FamilySitemapEntryFromJSON,
    FamilySitemapEntryToJSON,
    LocationSitemapEntryFromJSON,
    LocationSitemapEntryToJSON,
    TagSitemapEntryFromJSON,
    TagSitemapEntryToJSON,
} from '../models';

export interface GetFreelancerCategoriesRequest {
    locale?: string;
}

export interface GetFreelancerLocationsRequest {
    locale?: string;
}

export interface GetFreelancerTagsRequest {
    locale?: string;
}

/**
 * 
 */
export class SitemapApi extends runtime.BaseAPI {

    /**
          */
    async getFreelancerCategoriesRaw(requestParameters: GetFreelancerCategoriesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<FamilySitemapEntry>>> {
        const queryParameters: any = {};

        if (requestParameters['locale'] != null) {
            queryParameters['locale'] = requestParameters['locale'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<FamilySitemapEntry>>({
            path: `/cms/api/sitemap/freelancer/categories`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(FamilySitemapEntryFromJSON);
        return response;
    }

    /**
          */
    async getFreelancerCategories(requestParameters: GetFreelancerCategoriesRequest = {}, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<FamilySitemapEntry>> {
        const response = await this.getFreelancerCategoriesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async getFreelancerLocationsRaw(requestParameters: GetFreelancerLocationsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<LocationSitemapEntry>>> {
        const queryParameters: any = {};

        if (requestParameters['locale'] != null) {
            queryParameters['locale'] = requestParameters['locale'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<LocationSitemapEntry>>({
            path: `/cms/api/sitemap/freelancer/locations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(LocationSitemapEntryFromJSON);
        return response;
    }

    /**
          */
    async getFreelancerLocations(requestParameters: GetFreelancerLocationsRequest = {}, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<LocationSitemapEntry>> {
        const response = await this.getFreelancerLocationsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async getFreelancerTagsRaw(requestParameters: GetFreelancerTagsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<TagSitemapEntry>>> {
        const queryParameters: any = {};

        if (requestParameters['locale'] != null) {
            queryParameters['locale'] = requestParameters['locale'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<TagSitemapEntry>>({
            path: `/cms/api/sitemap/freelancer/tags`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(TagSitemapEntryFromJSON);
        return response;
    }

    /**
          */
    async getFreelancerTags(requestParameters: GetFreelancerTagsRequest = {}, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<TagSitemapEntry>> {
        const response = await this.getFreelancerTagsRaw(requestParameters, initOverrides);
        return response._data;
    }

}
